import { CubeReducerState, CubeStatus } from 'Cube/domain/cube.domain.types'

export const getIsAQuoteTemplate = (state: CubeReducerState) => {
  return state.data.common.status === CubeStatus.QuoteTemplate
}
